import React, { FC, PropsWithChildren, ReactNode, useMemo } from "react"
import tw from "tailwind-styled-components"
const CardWrapper = tw.section`
  mb-0
`

const CardTitleWrapper = tw.h2`
	text-xl
	px-6
	mb-4
`

const Card: FC<PropsWithChildren<{ title?: string | ReactNode }>> = ({ title, children }) => {
  const renderedTitle = useMemo(() => {
    switch (typeof title) {
      case "string": {
        return (
          <CardTitleWrapper>
            <h2 className="text-white text-opacity-60 text-md font-semibold">{title}</h2>
          </CardTitleWrapper>
        )
      }
      case "object": {
        return title
      }
    }
    return undefined
  }, [title])

  return (
    <CardWrapper>
      {renderedTitle}
      {children}
    </CardWrapper>
  )
}

export default Card
